//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { tidalTransitionExpand } from '@tidal/styles-animation';
import tidalIcon from '@tidal/styles-icons';
import { generalCheckmark, detailViewInfo } from '@tidal/styles-icons';

export default {
    components: {
        tidalTransitionExpand,
        tidalIcon,
    },
    props: {
        /** @type {import('vue').PropOptions<OfferWeb.FeaturesCopy | Array<any>>} */
        features: {
            type: [Object, Array],
            required: true,
        },
        highlightElement: {
            type: Number,
            default: null,
        },
        disableElement: {
            type: Number,
            default: null,
        },
        subscriptionType: {
            type: String,
            default: '',
        },
        enableThirdTier: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            /** @type {OfferWeb.LangFeature | null} */
            openedFeature: null,
            generalCheckmark,
            detailViewInfo,
            /** @type {{[key: string]: number}} */
            topFeaturesPerSubscriptionType: {
                PREMIUM: 1,
                PREMIUM_MID: 1,
                HIFI: 3,
                PREMIUM_PLUS: 3,
            },
            questionMarkIcon: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944
            21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM12 1C5.92487 1 1 5.92487 1 12C1 18.0751
            5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM11.03 14.16H12.9V13.91C12.9
            13.02 13.4 12.42 14 11.88C14.67 11.26 15.38 10.55 15.38 9.35C15.38 7.44 13.81 6.49 12.1 6.49C10.23
            6.49 8.64 7.49 8.62 9.69H10.53C10.53 8.89 11.08 8.26 11.85 8.26C12.68 8.26 13.28 8.7 13.28 9.48C13.28
            10.13 13.04 10.46 12.41 11.03C11.5 11.86 11.03 12.61 11.03 13.71V14.16ZM10.8 16.32C10.8 16.97 11.34
            17.51 12.02 17.51C12.71 17.51 13.24 16.96 13.24 16.31C13.24 15.65 12.71 15.12 12.02 15.12C11.33
            15.12 10.8 15.66 10.8 16.32Z" fill="white"/></svg>`,
        };
    },
    computed: {
        /** @returns {string} */
        thirdTierTickColor() {
            if (this.enableThirdTier) {
                switch (this.subscriptionType) {
                    case 'PREMIUM':
                        return 'third-tier-tick--premium';
                    case 'PREMIUM_MID':
                        return 'third-tier-tick--premium-mid';
                    case 'HIFI':
                    case 'PREMIUM_PLUS':
                        return 'third-tier-tick--premium-plus';
                }
            }
            return '';
        },
        /** @returns {string} */
        tidalIconClass() {
            return `${!this.enableThirdTier ? 'primary' : ''} ${this.thirdTierTickColor} font-size-intermediate text-align-intermediate`;
        },
        /** @returns {number} */
        numberOfTopFeatures() {
            return this.enableThirdTier && this.topFeaturesPerSubscriptionType[this.subscriptionType] || 0;
        },
        /** @returns {Array<OfferWeb.LangFeature>} */
        topFeatures() {
            return !Array.isArray(this.features) && this.features.subscriptionTypeFeatures?.slice(0, this.numberOfTopFeatures) || [];
        },
        /** @returns {Array<OfferWeb.LangFeature>} */
        standardFeatures() {
            return !Array.isArray(this.features) && this.features.subscriptionTypeFeatures?.slice(this.numberOfTopFeatures, this.enableThirdTier ? -1 : this.features.subscriptionTypeFeatures.length) || [];
        },
        /** @returns {Array<OfferWeb.LangFeature>} */
        planFeatures() {
            return !Array.isArray(this.features) && this.features.subscriptionPlanFeatures ? this.features.subscriptionPlanFeatures : [];
        },
        /** @returns {string} */
        topFeaturesCss() {
            if (this.enableThirdTier) {
                switch (this.subscriptionType) {
                    case 'PREMIUM':
                        return 'top-features-box premium';
                    case 'PREMIUM_MID':
                        return 'top-features-box premium-mid';
                    case 'HIFI':
                    case 'PREMIUM_PLUS':
                        return 'top-features-box premium-plus';
                }
            }
            return 'top-features-box';
        },
    },
    methods: {
        /** @param {OfferWeb.LangFeature} feature */
        openFeature(feature) {
            if (this.openedFeature === feature) {
                this.openedFeature = null;
            } else {
                this.openedFeature = feature;
            }
        },
    },
};
